"use client";

import { SidebarMenuButton } from "@workspace/frontend-ui";
import type { FC } from "react";
import DynamicHugeIcon from "../../../../utils/DynamicHugeIcon";
import { SIDEBAR_TOOLTIP_CLASS } from "../sidebarTooltip";

type ProtoWindow = Window & { proto?: { open: () => Promise<void> } };

type Props = {
  label?: string;
  chatLabel?: string;
};

const SupportButton: FC<Props> = ({
  label = "Support",
  chatLabel = "Chat",
}) => {
  const handleClick = () => {
    (window as ProtoWindow).proto?.open();
  };

  return (
    <SidebarMenuButton
      tooltip={{ children: label, className: SIDEBAR_TOOLTIP_CLASS }}
      onClick={handleClick}
      className="hover:text-sidebar-primary bg-sidebar-accent rounded-xl"
      size="md"
    >
      <DynamicHugeIcon iconName="CustomerService01Icon" />
      <span className="group-data-[collapsible=icon]:hidden flex-1">
        {label}
      </span>
      <span className="group-data-[collapsible=icon]:hidden flex items-center gap-1.5 text-xs text-sidebar-foreground/60">
        {chatLabel}
        <span className="h-2 w-2 rounded-full bg-green-500 shrink-0" />
      </span>
    </SidebarMenuButton>
  );
};

export default SupportButton;
